import { styled } from "@mui/material";
import { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import FamilyRestroomIcon from "@mui/icons-material/FamilyRestroom";
import HomeIcon from "@mui/icons-material/Home";
import PersonIcon from "@mui/icons-material/Person";
import SchoolIcon from "@mui/icons-material/School";
import BadgeIcon from "@mui/icons-material/Badge";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import LinearProgress from "@mui/material/LinearProgress";
import { surveyService } from "services/SurveyService";
import { SurveyContent } from "types";
import Link from "@mui/material/Link";
import { useSection } from "lib/context/section";

const SurveyContentComponent = ({ tokenId }: any) => {
  const [content, setContent] = useState<SurveyContent[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const { sectionId, setSectionId } = useSection();

  useEffect(() => {
    setLoading(true);
    if (tokenId) {
      surveyService
        .getSurveyContent(tokenId as string)
        .then((response: SurveyContent[]) => {
          setLoading(false);
          setContent(response);
        })
        .catch((error) => {
          setLoading(false);
          console.error("error", error);
        });
    }
  }, [tokenId]);

  const Icons = {
    COLABORADOR: <PersonIcon />,
    FORMACION: <SchoolIcon />,
    BIENESTAR: <BadgeIcon />,
    PROYECTOS: <AccountTreeIcon />,
    FAMILIA: <FamilyRestroomIcon />,
    VIVIENDA: <HomeIcon />,
  };

  const handleLastSection = (nextSection: number) => {
    setSectionId(nextSection);
  };

  const handleSection = (sectionInitial: number) => {
    setSectionId(sectionInitial);
  };

  return (
    <Paper sx={{ width: 650, maxWidth: "100%", padding: "1rem", height: 650 }}>
      <Title>
        <Typography variant='h5' align='center' color='primary'>
          Contenido de la encuesta
        </Typography>
      </Title>
      {loading ? (
        <LinearProgress />
      ) : (
        <nav aria-label='main mailbox folders'>
          <List>
            {content?.map((item: SurveyContent, index: number) => {
              const { module, description, descLink, nextSection, sectionInitial, sectionFinal, enabled } = item || {};
              return (
                <ListItem key={index}>
                  <ListItemIcon>{Icons[module as keyof typeof Icons]}</ListItemIcon>
                  <ListItemText>{description}</ListItemText>
                  {descLink ? (
                    <Link component='button' onClick={() => handleLastSection(nextSection as number)}>
                      <Typography variant='body2' color='text.secondary'>
                        {descLink}
                      </Typography>
                    </Link>
                  ) : enabled ? (
                    <Link component='button' onClick={() => handleSection(sectionInitial as number)}>
                      <Typography variant='body2' color='text.secondary'>
                        Secciones {sectionInitial} a {sectionFinal}
                      </Typography>
                    </Link>
                  ) : (
                    <Typography variant='body2' color='text.disabled'>
                      Secciones {sectionInitial} a {sectionFinal}
                    </Typography>
                  )}
                </ListItem>
              );
            })}
          </List>
        </nav>
      )}
    </Paper>
  );
};

export default SurveyContentComponent;

const Title = styled("div")`
  padding-top: 2rem;
  padding-bottom: 2rem;
`;
